var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof platformAuthz !== "undefined") return resolve();
	__webpack_require__.l("__MFE_URL_PLACEHOLDER__/platformAuthz/mf-manifest.json", function(event) {
		if(typeof platformAuthz !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "platformAuthz");
}).then(function() { return platformAuthz; });